<p-card [class.proposal-section--valid]="completed">
  <h3 class="text-center" i18n>Choisissez le plan du client</h3>

  <div class="flex flex-row align-items-center gap-3">
    <em-needs-reminder-section [needs]="needs" class="w-full"></em-needs-reminder-section>
    @if (willRequireExtraRequirements) {
      <div class="layout__inner-card bg-yellow-200 align-self-stretch">
        <h4 i18n>Exigences médicales</h4>
        <p i18n
          >Des exigences médicales seront commandées pour votre client en tarification, voir la grille de
          sélection pour plus de détails.</p
        >
      </div>
    }
  </div>

  @if (!readonly) {
    <div class="flex flex-row gap-6 my-5">
      <em-whole-life-card
        class="w-full"
        (coverageSelected)="updateLifeInsurance($event)"
        [ratesVersion]="ratesVersion"
        [age]="age"
        [smoker]="smoker"
        [sex]="sex"
        [selectedDuration]="selectedWholeLifeDuration"
        [selectedWholeLifeCoverageAmount]="selectedWholeLifeCoverageAmount"
        [selectedTermLifeCoverageAmount]="selectedTermLifeCoverageAmount"></em-whole-life-card>
      <em-term-life-card
        class="w-full"
        (coverageSelected)="updateLifeInsurance($event)"
        [ratesVersion]="ratesVersion"
        [age]="age"
        [smoker]="smoker"
        [sex]="sex"
        [selectedDuration]="selectedTermLifeDuration"
        [selectedTermLifeCoverageAmount]="selectedTermLifeCoverageAmount"
        [selectedWholeLifeCoverageAmount]="selectedWholeLifeCoverageAmount"></em-term-life-card>
    </div>
    <div class="flex flex-row gap-3 my-5">
      <em-child-rider-card
        class="w-full"
        (coverageSelected)="updateRider($event)"
        [ratesVersion]="ratesVersion"
        [selectedRiderCoverageAmount]="selectedChildRiderCoverageAmount"
        [selectedLifeInsuranceCoverageAmount]="
          (selectedWholeLifeCoverageAmount ?? 0) + (selectedTermLifeCoverageAmount ?? 0)
        "></em-child-rider-card>
      <em-disability-rider-card
        class="w-full"
        (coverageSelected)="updateRider($event)"
        [ratesVersion]="ratesVersion"
        [jobRiskClass]="jobRiskClass"
        [age]="age"
        [smoker]="smoker"
        [sex]="sex"
        [selectedRiderCoverageAmount]="selectedDisabilityRiderCoverageAmount"
        [selectedRiderDuration]="selectedDisabilityRiderDuration"
        [selectedLifeInsuranceCoverageAmount]="
          (selectedWholeLifeCoverageAmount ?? 0) + (selectedTermLifeCoverageAmount ?? 0)
        "></em-disability-rider-card>
      <em-cancer-rider-card
        class="w-full"
        (coverageSelected)="updateRider($event)"
        [ratesVersion]="ratesVersion"
        [selectedRiderCoverageAmount]="selectedCancerRiderCoverageAmount"></em-cancer-rider-card>
    </div>
  }

  <em-selected-product-section [protection]="_selectedProtection"></em-selected-product-section>
</p-card>
